module.exports = __webpack_public_path__ + "img/phonelink_off.21001bb6.svg";